// src/config/theme.js
export const theme = {
    token: {
      colorPrimary: '#202835',
      colorBgContainer: '#ffffff',
      colorText: '#202835',
      borderRadius: 13,
      fontSize: 14,
      fontFamily: 'Inter, sans-serif',
    },
    components: {
      Menu: {
        // DataTransfer
        itemHeight: 48,
        itemHoverColor: '#202835',
        itemHoverBg: '#F8F9FC',
        itemSelectedBg: '#202835',
        itemSelectedColor: '#ffffff',
        itemMarginInline: 8,
        padding: 10,
        iconSize: 18,
        fontSize: 13,
      },
      Layout: {
        siderBg: '#ffffff',
        triggerBg: '#f8f9fc',
        triggerColor: '#202835',
      },
      Button: {
        borderRadius: 6,
        controlHeight: 48,
      },
      Input: {
        controlHeight: 48,
      },
    },
  };